export default __webpack_public_path__ + "static/media/ic_js.6c910e17.png";